import React, { useEffect, useState } from 'react'

import { UsersSelect } from './UsersSelect'
import { gql, useMutation } from '@apollo/client'

const SET_LEAD_ASSIGNEES_MUTATION = gql`
  mutation setLeadAssignees($leadId: ID!, $userIds: [ID!]) {
    setLeadAssignees(leadId: $leadId, userIds: $userIds) {
      assignees {
        id
      }
    }
  }
`

export function AssignUsersToLeadSelect({
  lead,
  users,
  onCompleted
}) {
  const [userIds, setUserIds] = useState(lead?.assignees?.map(a => a?.user?.username) ?? [])

  useEffect(() => {
    setUserIds(lead?.assignees?.map(a => a?.user?.username) ?? [])
  }, [lead])

  const [
    setLeadAssignees,
    {
      loading: saving
    }
  ] = useMutation(
    SET_LEAD_ASSIGNEES_MUTATION,
    {
      onCompleted
    }
  )

  const handleSelectedUsers = (values) => {
    setUserIds(values)
  }

  const handleClose = (event) => { 
    setLeadAssignees({
      variables: {
        userIds,  
        leadId: lead.slug
      }
    }).then(() => {

    })
  }

  return (
    <UsersSelect
      loading={saving}
      selectedUserIds={userIds}
      users={users}
      onChange={handleSelectedUsers}
      onClose={handleClose}
    />
  )
}